import { type Html } from 'rune-ts';
import { ClockFillIcon } from '../../../atoms/Icon';
import { ProductBadgeBase } from '../ProductBadgeBase';
import { ProductTimeHelper } from '../../ProductCard/utils/ProductTimeHelper';
import { ProductBadgeHelper } from '../ProductBadgeHelper';
import klass from '../styles/ProductBadge.module.scss';
import { ProductBadgeStyleHelper } from '../ProductBadgeStyleHelper.ts';

export class PeriodLimitedBadge extends ProductBadgeBase<Date> {
  protected setLabel(): void {
    const now = new Date();
    const diff = ProductTimeHelper.diffDate(this.data.value, now);
    const options = { ...diff, lng: this.data.option.lang };

    // 4일 이상이면 숨겨진다.
    if (!this.isVisible()) {
      this.label = undefined;
      return;
    }
    if (diff.day > 0) {
      this.label = ET('mps2::product::badge::period_limited_day', options);
      return;
    }
    if (diff.hour > 0) {
      this.label = ET('mps2::product::badge::period_limited_hour', options);
      return;
    }
    if (diff.minute > 0) {
      this.label = ET('mps2::product::badge::period_limited_minute', options);
      return;
    }
    this.label = ET('mps2::product::badge::period_limited_second', options);
  }

  protected isTimerNeeded(): boolean {
    return this.isVisible();
  }

  protected getIcon(): Html | string | null {
    return ClockFillIcon;
  }

  public override isVisible(): boolean {
    return ProductBadgeHelper.isPeriodLimitedBadgeLabelVisible(this.data.value);
  }

  protected getStyles(): string {
    return klass.period_limited;
  }

  protected getTypo(): string {
    return ProductBadgeStyleHelper.getBaseTypo(this.data.option.size);
  }
}
